import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Phone from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import es from 'react-phone-input-2/lang/es.json';
import fr from 'react-phone-input-2/lang/fr.json';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const lang = {
  es: es,
  fr: fr,
  'es-ES': es,
  'fr-FR': fr
};

const PhoneInput = ({
  className,
  country,
  value,
  onChange,
  label,
  id,
  countryCodeEditable,
  extraClassName,
  localization,
  ...props
}) => {
  const [isFocus, setIsFocus] = useState(false);
  const { t } = useTranslation('General');

  return (
    <div className={className} data-testid="phone-input">
      <div className="phone-input">
        <label
          className={cx('phone-input__phone-label', {
            'phone-input__phone-label--filled': isFocus || !!value || !!country
          })}
          htmlFor={id}
        >
          {label}
        </label>
        <Phone
          inputProps={{
            id,
            autoComplete: 'off',
            onFocus: () => setIsFocus(true),
            onBlur: () => setIsFocus(false),
            'data-testid': id,
            autoFocus: true
          }}
          localization={lang[localization]}
          placeholder=""
          country={country?.toLowerCase()}
          value={value}
          onChange={onChange}
          countryCodeEditable={countryCodeEditable}
          enableSearch={true}
          disableSearchIcon={true}
          containerClass="phone-input__phone"
          inputClass={'phone-input__phone-input'}
          buttonClass="phone-input__phone-button"
          dropdownClass="phone-input__phone-dropdown"
          searchPlaceholder={t('search')}
          {...props}
        />
      </div>
    </div>
  );
};

PhoneInput.defaultProps = {
  value: '',
  error: false,
  countryCodeEditable: false,
  extraClassName: '',
  localization: 'es'
};

PhoneInput.propTypes = {
  className: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  countryCodeEditable: PropTypes.bool,
  extraClassName: PropTypes.string
};
export default PhoneInput;
